"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _treatmentsalequantity = require("@/api/treatmentsalequantity");
var _org = require("@/api/org");
var _config_preparations = require("@/api/config_preparations");
var _treatmentpartadjust = require("@/api/treatmentpartadjust");
var _device_salesorder = require("@/api/device_salesorder");
var _user = require("@/api/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultTreatmentPartSaleQuantity = {
  treatment: [{
    treatment_preparations: '',
    num: null
  }],
  receiving_medical_no: '',
  order_amount: null,
  pre_shiptime: null,
  sales: '',
  sales_name: '',
  remark: ''
};
var defaultApproval = {
  approval_status: null,
  approval_remark: ''
};
var defaultShipment = {
  receiving_medical_addr: null,
  receiving_medical_contact: null,
  receiving_medical_phone: null,
  receiving_medical_type: null,
  shiptime: null,
  courier: null,
  shipnum: null,
  receiving_remark: ''
};
var checkNumber = function checkNumber(rule, value, callBack) {
  if (!Number(value * 1) && value * 1 !== 0) {
    callBack(new Error('请输入合法的数值'));
  } else {
    if (value * 1 < 0) {
      callBack(new Error('金额不能小于0'));
    } else {
      callBack();
    }
  }
};
var _default = exports.default = {
  data: function data() {
    return {
      dialogTransformLoading1: false,
      transformData1: {
        results: []
      },
      viewDialog1: false,
      listLoading: true,
      tableData: [],
      treatmentpartsalequantity: defaultTreatmentPartSaleQuantity,
      treatmentapproval: defaultApproval,
      treatmentshipment: defaultShipment,
      dialogVisible: false,
      approvalDialog: false,
      viewDialog: false,
      shipmentDialog: false,
      dialogType: 'new',
      number: '',
      rule1: {
        treatment: [{
          required: true,
          message: '请选择制剂及数量',
          trigger: 'change'
        }],
        order_amount: [{
          required: true,
          message: '请输入订单金额',
          trigger: 'blur'
        }, {
          validator: checkNumber
        }],
        receiving_medical_no: [{
          required: true,
          message: '请输入收货医疗机构编号',
          trigger: 'blur'
        }],
        // receiving_medical_name: [{ required: true, message: '', trigger: 'blur' }],
        pre_shiptime: [{
          required: true,
          message: '请输入预发货时间',
          trigger: 'blur'
        }],
        sales: [{
          required: true,
          message: '请输入销售员编码',
          trigger: 'blur'
        }],
        sales_name: [{
          required: true,
          message: '非法人员请重新输入编码',
          trigger: 'blur'
        }],
        remark: [{
          max: 200,
          message: '输入长度不能超过200位',
          trigger: 'change'
        }]
      },
      rule2: {
        approval_status: [{
          required: true,
          message: '请选择审核状态',
          trigger: 'change'
        }],
        approval_remark: [{
          max: 200,
          message: '输入长度不能超过200位',
          trigger: 'change'
        }]
      },
      rule3: {
        receiving_medical_addr: [{
          required: true,
          message: '请输入收货医疗机构地址',
          trigger: 'blur'
        }],
        receiving_medical_contact: [{
          required: true,
          message: '请输入收货医疗机构联系人',
          trigger: 'blur'
        }],
        receiving_medical_phone: [{
          required: true,
          message: '请输入收货医疗机构联系人电话',
          trigger: 'blur'
        }],
        receiving_medical_type: [{
          required: true,
          message: '请选择收货医疗机构类型',
          trigger: 'change'
        }],
        shiptime: [{
          required: true,
          message: '请输入发货时间',
          trigger: 'blur'
        }],
        courier: [{
          required: true,
          message: '请输入快递公司',
          trigger: 'blur'
        }],
        shipnum: [{
          required: true,
          message: '请输入发货单号',
          trigger: 'blur'
        }],
        receiving_remark: [{
          max: 200,
          message: '输入长度不能超过200位',
          trigger: 'change'
        }]
      },
      statusOptions: [{
        value: 1,
        label: '待审核'
      }, {
        value: 2,
        label: '待发货'
      }, {
        value: 3,
        label: '拒绝'
      }, {
        value: 4,
        label: '完成'
      }],
      listQuery: {
        page: 1,
        page_size: 20
      },
      orgList: [],
      treatmentList: [],
      quantity: '',
      receiving_medical_name: '',
      apprvoalOptions: [{
        value: 1,
        label: '通过'
      }, {
        value: 2,
        label: '拒绝'
      }],
      apprvoalOptions1: [{
        value: 2,
        label: '通过'
      }, {
        value: 3,
        label: '拒绝'
      }, {
        value: 4,
        label: '通过'
      }],
      typeOptions: [{
        value: 1,
        label: '私立医院'
      }, {
        value: 2,
        label: '公立医院'
      }],
      user_id: ''
    };
  },
  created: function created() {
    this.getList();
    this.getTreatmentList();
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
      this.listQuery.page_size = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: ".concat(val));
      this.listQuery.page = val;
      this.getList();
    },
    checkPermission: _permission.default,
    handleAdd: function handleAdd() {
      var _this = this;
      this.treatmentpartsalequantity = Object.assign({}, defaultTreatmentPartSaleQuantity);
      this.treatmentpartsalequantity.treatment = [{
        treatment_preparations: '',
        num: null
      }];
      this.quantity = '';
      this.receiving_medical_name = '';
      this.dialogType = 'new';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this.$refs['Form'].clearValidate();
      });
    },
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _treatmentsalequantity.getTreatmentPartSaleQuantity)(this.listQuery).then(function (response) {
        if (response.data) {
          // console.log(response.data)
          _this2.tableData = response.data;
        }
        _this2.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(scope) {
        var _this3 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.treatmentpartsalequantity = Object.assign({}, scope.row); // copy obj
              this.user_id = this.treatmentpartsalequantity.sales;
              _context.next = 4;
              return (0, _user.getUser)(this.treatmentpartsalequantity.sales).then(function (response) {
                _this3.$set(_this3.treatmentpartsalequantity, 'sales', response.data.user_id);
                _this3.$set(_this3.treatmentpartsalequantity, 'sales_name', response.data.username);
              });
            case 4:
              console.log(this.treatmentpartsalequantity);
              this.getName();
              this.dialogType = 'edit';
              this.dialogVisible = true;
              this.$nextTick(function () {
                _this3.$refs['Form'].clearValidate();
              });
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    handleDelete: function handleDelete(scope) {
      var _this4 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _treatmentsalequantity.deleteTreatmentPartSaleQuantity)(scope.row.id);
            case 2:
              // this.tableData.splice($index, 1)
              _this4.getList();
              _this4.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    handleView: function handleView(scope) {
      this.transformData1.results = [];
      this.treatmentpartsalequantity = Object.assign({}, scope.row);
      this.viewDialog1 = true;
      this.transformData1.results.push(this.treatmentpartsalequantity);
    },
    handleApproval: function handleApproval(scope) {
      var _this5 = this;
      this.treatmentpartsalequantity = Object.assign({}, scope.row);
      this.treatmentapproval = Object.assign({}, defaultApproval);
      this.addQuantity();
      this.getName1();
      this.approvalDialog = true;
      this.$nextTick(function () {
        _this5.$refs['approvalForm'].clearValidate();
      });
    },
    handleShipment: function handleShipment(scope) {
      var _this6 = this;
      this.treatmentpartsalequantity = Object.assign({}, scope.row);
      this.treatmentshipment = Object.assign({}, defaultShipment);
      this.getName2();
      this.treatmentshipment.receiving_medical_type = scope.row.receiving_medical_type;
      this.shipmentDialog = true;
      this.$nextTick(function () {
        _this6.$refs['shipmentForm'].clearValidate();
      });
    },
    getName1: function getName1() {
      var _this7 = this;
      console.log(this.treatmentpartsalequantity.receiving_medical_no);
      if (this.treatmentpartsalequantity.receiving_medical_no !== '') {
        this.listQuery.dept_no = this.treatmentpartsalequantity.receiving_medical_no;
        (0, _org.getOrgList)(this.listQuery).then(function (response) {
          if (response.data) {
            console.log(response.data);
            _this7.treatmentpartsalequantity.receiving_medical_addr = response.data[0].province_name + response.data[0].city_name + response.data[0].district_name + response.data[0].addrs;
            (0, _user.getUser)(response.data[0].charge_name).then(function (res) {
              _this7.treatmentpartsalequantity.receiving_medical_contact = res.data.name;
            });
            // this.treatmentpartsalequantity.receiving_medical_contact = response.data[0].charge_name
            _this7.treatmentpartsalequantity.receiving_medical_phone = response.data[0].charge_contact;
          } else {
            _this7.treatmentpartsalequantity.receiving_medical_addr = '';
            _this7.treatmentpartsalequantity.receiving_medical_contact = '';
            _this7.treatmentpartsalequantity.receiving_medical_phone = '';
          }
        });
        console.log(this.treatmentpartsalequantity.receiving_medical_name);
      } else {
        this.treatmentpartsalequantity.receiving_medical_addr = '';
        this.treatmentpartsalequantity.receiving_medical_contact = '';
        this.treatmentpartsalequantity.receiving_medical_phone = '';
      }
    },
    getName2: function getName2() {
      var _this8 = this;
      console.log(this.treatmentpartsalequantity.receiving_medical_no);
      if (this.treatmentpartsalequantity.receiving_medical_no !== '') {
        this.listQuery.dept_no = this.treatmentpartsalequantity.receiving_medical_no;
        (0, _org.getOrgList)(this.listQuery).then(function (response) {
          if (response.data) {
            console.log(response.data);
            _this8.treatmentshipment.receiving_medical_addr = response.data[0].province_name + response.data[0].city_name + response.data[0].district_name + response.data[0].addrs;
            (0, _user.getUser)(response.data[0].charge_name).then(function (res) {
              _this8.treatmentshipment.receiving_medical_contact = res.data.name;
            });
            // this.treatmentshipment.receiving_medical_contact = response.data[0].charge_name
            _this8.treatmentshipment.receiving_medical_phone = response.data[0].charge_contact;
          } else {
            _this8.treatmentshipment.receiving_medical_addr = '';
            _this8.treatmentshipment.receiving_medical_contact = '';
            _this8.treatmentshipment.receiving_medical_phone = '';
          }
        });
        console.log(this.treatmentshipment.receiving_medical_name);
      } else {
        this.treatmentshipment.receiving_medical_addr = '';
        this.treatmentshipment.receiving_medical_contact = '';
        this.treatmentshipment.receiving_medical_phone = '';
      }
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(form) {
        var _this9 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this9.dialogType === 'edit';
                  if (isEdit) {
                    _this9.treatmentpartsalequantity.sales = _this9.user_id;
                    delete _this9.treatmentpartsalequantity.sales_name;
                    _this9.treatmentpartsalequantity.status = 1;
                    (0, _treatmentsalequantity.updateTreatmentPartSaleQuantity)(_this9.treatmentpartsalequantity.id, _this9.treatmentpartsalequantity).then(function (res) {
                      _this9.getList();
                      _this9.dialogVisible = false;
                      _this9.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    }).catch(function (error) {
                      console.log(2, error);
                      (0, _user.getUser)(_this9.treatmentpartsalequantity.sales).then(function (response) {
                        _this9.$set(_this9.treatmentpartsalequantity, 'sales', response.data.user_id);
                        _this9.$set(_this9.treatmentpartsalequantity, 'sales_name', response.data.username);
                      });
                      console.log(_this9.treatmentpartsalequantity);
                    });
                  } else {
                    _this9.treatmentpartsalequantity.sales = _this9.user_id;
                    delete _this9.treatmentpartsalequantity.sales_name;
                    console.log(_this9.treatmentpartsalequantity);
                    (0, _treatmentsalequantity.createTreatmentPartSaleQuantity)(_this9.treatmentpartsalequantity).then(function (res) {
                      _this9.getList();
                      _this9.dialogVisible = false;
                      _this9.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    }).catch(function (error) {
                      console.log(2, error);
                      (0, _user.getUser)(_this9.treatmentpartsalequantity.sales).then(function (response) {
                        _this9.$set(_this9.treatmentpartsalequantity, 'sales', response.data.user_id);
                        _this9.$set(_this9.treatmentpartsalequantity, 'sales_name', response.data.username);
                      });
                      console.log(_this9.treatmentpartsalequantity);
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function confirm(_x2) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    getName: function getName() {
      var _this10 = this;
      if (this.treatmentpartsalequantity.receiving_medical_no) {
        (0, _org.getOrgList)({
          dept_no: this.treatmentpartsalequantity.receiving_medical_no
        }).then(function (response) {
          if (response.data) {
            console.log(response.data);
            _this10.receiving_medical_name = response.data[0].name;
          } else {
            _this10.receiving_medical_name = '';
          }
          console.log(_this10.receiving_medical_name);
        });
      }
    },
    getSaleName: function getSaleName() {
      var _this11 = this;
      console.log(this.treatmentpartsalequantity.sales);
      if (this.treatmentpartsalequantity.sales) {
        (0, _user.getUserList)({
          user_id: this.treatmentpartsalequantity.sales
        }).then(function (response) {
          if (response.data.results) {
            if (response.data.results[0].commission_branches === '新汉方公司') {
              _this11.$set(_this11.treatmentpartsalequantity, 'sales_name', response.data.results[0].username);
              _this11.user_id = response.data.results[0].id;
            } else {
              _this11.treatmentpartsalequantity.sales_name = '';
            }
          } else {
            _this11.treatmentpartsalequantity.sales_name = '';
          }
        });
      } else {
        this.treatmentpartsalequantity.sales_name = '';
      }
    },
    addQuantity: function addQuantity() {
      var sum = 0;
      for (var i = 0; i < this.treatmentpartsalequantity.treatment.length; i++) {
        sum = sum + Number(this.treatmentpartsalequantity.treatment[i].num);
        console.log(sum);
      }
      this.quantity = sum;
    },
    addTreatment: function addTreatment() {
      this.treatmentpartsalequantity.treatment.push({
        treatment_preparations: '',
        num: null
      });
    },
    getTreatmentList: function getTreatmentList() {
      var _this12 = this;
      (0, _config_preparations.getPreparationsAll)().then(function (response) {
        _this12.treatmentList = response.data;
      });
    },
    confirmApproval: function () {
      var _confirmApproval = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(form) {
        var _this13 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  (0, _treatmentsalequantity.approvalTreatmentPartSaleQuantity)(_this13.treatmentpartsalequantity.id, _this13.treatmentapproval).then(function (res) {
                    if (_this13.treatmentapproval.approval_status === 1) {
                      _this13.getList();
                      _this13.approvalDialog = false;
                      _this13.$message({
                        message: '审核通过',
                        type: 'success'
                      });
                    } else if (_this13.treatmentapproval.approval_status === 2) {
                      _this13.getList();
                      _this13.approvalDialog = false;
                      _this13.$message({
                        message: '审核拒绝',
                        type: 'error'
                      });
                    }
                  });
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function confirmApproval(_x3) {
        return _confirmApproval.apply(this, arguments);
      }
      return confirmApproval;
    }(),
    confirmShipment: function () {
      var _confirmShipment = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(form) {
        var _this14 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  (0, _treatmentsalequantity.shipmentTreatmentPartSaleQuantity)(_this14.treatmentpartsalequantity.id, _this14.treatmentshipment).then(function (response) {
                    if (response.data) {
                      _this14.getList();
                      _this14.shipmentDialog = false;
                      _this14.$message({
                        message: '发货成功',
                        type: 'success'
                      });
                    }
                  });
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function confirmShipment(_x4) {
        return _confirmShipment.apply(this, arguments);
      }
      return confirmShipment;
    }()
  }
};